import React from 'react';
import pkg from '../package.json';
import './AboutModal.css';  // (optional, can reuse HelpModal styles)

function AboutModal({ open, onClose }) {
  if (!open) return null;
  const buildId = process.env.REACT_APP_BUILD || process.env.REACT_APP_COMMIT || '';

  return (
    <div className="modal-overlay">
      <div className="about-modal-content">
        <button className="modal-close" onClick={onClose} aria-label="Close">
          <svg xmlns="http://www.w3.org/2000/svg" height="24" width="24" viewBox="0 0 24 24" fill="currentColor">
            <path d="M0 0h24v24H0z" fill="none"/>
            <path d="M18.3 5.71a1 1 0 0 0-1.41 0L12 10.59 7.11 5.7a1 1 0 1 0-1.41 1.41L10.59 12l-4.89 4.89a1 1 0 1 0 1.41 1.41L12 13.41l4.89 4.89a1 1 0 0 0 1.41-1.41L13.41 12l4.89-4.89a1 1 0 0 0 0-1.4z"/>
          </svg>
        </button>        <h2>About Crackle</h2>
        <p>
          Crackle is an original code-breaking game with elements of Mastermind, Wordle and computer 
          programming.  The codes consist of hexadecimal digits (0–9 and A–F) and each level gets
          progressively harder, testing your logic and pattern recognition skills.
        </p>
        <p>
          This game was built as an experiment in Vibe Coding.  The designer had never built a .jsx/.css app 
          before and had never used React.  With the help of AI, the design was successfully implemented and
          deployed as you see it here.  The Intellectual Property is owned by 1742011 Ontario Corp.
        </p>
        <p>
          Version: {pkg.version}{buildId ? ` (${buildId})` : ''}
        </p>
        <p>
          &copy; {new Date().getFullYear()} Crackle Game. All rights reserved.
        </p>
      </div>
    </div>
  );
}

export default AboutModal;
